import React, {Component} from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
//import Login from "./App";
import Pagination from "react-js-pagination";
import Add_ticket from './../../assets/images/add.png';
import MenuItem from 'material-ui/MenuItem';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AutoComplete from 'material-ui/AutoComplete';
import SelectField from 'material-ui/SelectField';
import $ from 'jquery';
import Header from './../../Header';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class TodoList extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = this.decrypt(localStorage.getItem('encdata'), 0);
        this.searchChange = this.searchChange.bind(this);
        this.priortyChange = this.priortyChange.bind(this);
        this.statusChange = this.statusChange.bind(this);
        this.ownerChange = this.ownerChange.bind(this);
        this.sortByChange = this.sortByChange.bind(this); 
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.alertEditMessage = this.alertEditMessage.bind(this);
        this.alertViewMessage = this.alertViewMessage.bind(this);
        
        this.state = {
            todos: [],
            owners: [],
            status:[],
            priority:[],
            todoid:'',
            status_name: '',
            priority_name: '',
            sortBy: '',
            search: '',
            config: '',
            message: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            owner: has_local_data ? localdata.user_id : '',
            userId: has_local_data ? localdata.user_id : '',
            activePage: 1,
            item_count: '',
            loading: 1,
            isLoadMore: 1,
            orderBy: 'desc',
            order_col: 'created_date',
        };
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }
      
    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    handleSort(columnSort) {
        var columnName = 'todo_' + columnSort;
        var orderBy, arrow;
        //alert(this.state.orderBy);
        if(this.state.orderBy == 'desc'){
            orderBy = 'asc';
            arrow = '<i class= "fas fa-arrow-down leftmargin"></i>';
        }
        else{
            orderBy = 'desc';
            arrow = '<i class= "fas fa-arrow-up leftmargin"></i>';  
        }
        //Function of Arrow
        var prev_col =this.state.order_col;
        var prev_dynamic_id = 'todo_'+prev_col;
        if(document.getElementById(prev_dynamic_id))
            document.getElementById(prev_dynamic_id).innerHTML = document.getElementById(prev_dynamic_id).textContent;
        //End
        localStorage.setItem('orderBy', orderBy);
        localStorage.setItem('order_col', columnSort);
        this.setState({orderBy: orderBy,order_col: columnSort},function(){
            var a = document.getElementById(columnName).textContent;
            var b = a+arrow;
            document.getElementById(columnName).innerHTML = b;
            this.todoList();
        });
        
    }
    // Reset() {
    //     var all_filters= this.getAllfilterKeys();
    //     for(var key in all_filters) {
    //         localStorage.setItem(all_filters[key],'');
    //         this.setState({[all_filters[key]]: ''});
    //     }
    //     var obj = this;
    //     setTimeout(function() {
    //         obj.todoList();
    //     },100);
    // }   
    // getAllfilterKeys(){
    //     var filter_keys =  ["owner","status_name","priority_name"];
    //     return filter_keys;
    // }
    // onlyUnique(value, index, self) {
    //     return self.indexOf(value) === index;
    // }

    back(){
        window.location.href='/todos';
    }
    keywordChange(event){
        this.setState({search: event.target.value,
         activePage:1,
         loading:1,
     }, function () {
         this.todoList();
      });
    }
    searchChange(event) {
        var obj = this;
        this.setState({search: event.target.value,activePage: 1});
        var val = event.target.value;
        //Delaying the function execute
        if (this.timer) {
            window.clearTimeout(this.timer);
    }
        this.timer = window.setTimeout(function() {
            localStorage.setItem('search',document.getElementById('search').value);
            //Execute the function code here...
            obj.todoList();
        }, 500);
        // this.setState({search: event.target.value}, function () {
        //     this.todoList();
        // });
    }

    handlePageChange(pageNumber) {
        this.setState({activePage: pageNumber});
        this.todoList(pageNumber);
      }

    

    priortyChange(event) {
        this.setState({priority_name: event.target.value}, 
            function () {
            this.todoList();
        });
    }
    
    statusChange(event) {
        this.setState({
            status_name: event.target.value,
        }, function () {
            console.log(this.state.status);
            this.todoList();
        });
    }

    ownerChange(event) {
        localStorage.setItem(event.target.name,event.target.value);
        var obj = this;
        this.setState({owner: event.target.value}, function () {
            
            this.todoList();
        });
    }

    sortByChange(event){
        this.setState({sortBy: event.target.value}, function () {
            this.todoList();
        });
    }
    jumpSubmit(event)
    {
        if (event.key == 'Enter') {
            if(!event.target.value.match(/^[0-9]+$/)){
                this.setState({message:'Only numbers'}) 
                return false;
            }
            else {
                fetch(this.state.apiUrl + '/todoRest/viewTodoId/id/' + event.target.value + '/userAuthKey/' + this.state.userAuthKey)
                    .then((Response) => Response.json())
                    .then((responseJson) => {
                        responseJson = this.decrypt(responseJson, 1);
                        if (responseJson.code == 200) {
                            window.location.href = '/viewTodo/' + responseJson.todoid
                            } else {
                                this.setState({message:responseJson.msg}) 
                            }                      
                })
               
            }            
        }
    }
    todoList(page = 1) {
        $(document).ready(function(){
            $('.loader-new').removeClass('hidden');
            $('.list_check').addClass('hidden');
        });
        fetch(this.state.apiUrl + '/todoRest/getTodos/page/'+page+'/userAuthKey/'+ this.state.userAuthKey+'/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
        .then((Response) => Response.json())
        .then((findresponse) =>
        {
            $(document).ready(function(){
                $('.loader-new').addClass('hidden');
                $('.list_check').removeClass('hidden');
            });
                findresponse = this.decrypt(findresponse, 1);
            this.setState({
                loading:0,
                todos: findresponse.todos,
                owners: findresponse.owner,
                item_count: findresponse.item_count,
                config:findresponse.config,
                userid:findresponse.userid,
            })
        })
    }
    addTodoDetails() {
        fetch(this.state.apiUrl + '/TodoRest/Adddetails/userAuthKey/'+ this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
                .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                            window.location.href = '/todos';
                        }); 
                    } else {
                    
                        this.setState({message:findresponse.msg}) 
                    }
                    this.setState({
                        owners: findresponse.owner,
                        priority:findresponse.priority,
                        status:findresponse.status,
                    })
                })
    }
    alertViewMessage(todoid){
        fetch(this.state.apiUrl + '/TodoRest/AlertViewMessage/id/'+todoid+'/userId/'+this.state.userId+'/userAuthKey/'+ this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
        .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.decrypt(responseJson, 1);
                if (responseJson.id_error == 0) {
                    window.location.href = '/viewTodo/' + todoid;
                } else {
                                window.location.href = '/Unauthorized';
                            }
        })  
    }
    alertEditMessage(todoid){
        fetch(this.state.apiUrl + '/TodoRest/AlertEditMessage/id/'+todoid+'/userId/'+this.state.userId+'/userAuthKey/'+ this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
        .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.decrypt(responseJson, 1);
                if (responseJson.id_error == 0) {
                    window.location.href = '/updateTodo/' + todoid;
                } else {
                                window.location.href = '/Unauthorized';
                            }
        })  
    }

    getTodoRows(){
        if(this.state.loading){
           return (
            <div class="loader-new"></div>
           )
        }else{
            return (
                <div>
                <div class= "loader-new"></div>
                <div class="list_check hidden">
                <div class="tickets hidden-sm">
                <ul class="tickets_head er_head">
                    <li class="intra_col_8" id="todo_id"   onClick={this.handleSort.bind(this, 'id')}>#To Do</li>
                    <li class="intra_col_25" id="todo_title" onClick={this.handleSort.bind(this, 'title')}>Title</li>
                    <li class="intra_col_20">Owner</li>
                    <li class="intra_col_8" id="todo_priority"   onClick={this.handleSort.bind(this, 'priority')}>Priority</li>
                    <li class="intra_col_9" id="todo_status"  onClick={this.handleSort.bind(this, 'status')}>Status</li>
                    <li class="intra_col_8" id="todo_ETA" onClick={this.handleSort.bind(this, 'ETA')}>ETA</li>
                    <li class="intra_col_15" id="todo_created_date" onClick={this.handleSort.bind(this, 'created_date')}>Reported On</li>
                    <li class="intra_col_5">Action</li>
                   
                </ul>
                {
                this.state.todos.map((todo,key)=>
                <ul class="tickets_number">
                    <li class="intra_col_8"><a onClick={event => {this.alertViewMessage(todo.id)}}>{"TD"+todo.id}</a></li>
                    <li class="intra_col_25 text-inded">{todo.title}</li>
                    <li class="intra_col_20"> {todo.owner_name} </li>
                    <li class="intra_col_8">{todo.priority?this.state.config.priority[todo.priority]:'--'}</li>
                    <li class="intra_col_9"> {todo.status?this.state.config.status[todo.status]:'--'}</li>
                    <li class="intra_col_8">{todo.ETA != '00-00-0000' && todo.ETA!=''? todo.ETA: '--'}</li>
                    <li class="intra_col_15">{todo.created_date}</li>    
                    <li class="intra_col_5"><a onClick={event => {this.alertEditMessage(todo.id)}}><i class="far fa-edit"></i></a></li>                                    
                </ul>
                    )
                }
            </div>
            <div class="tickets_mob hidden-md">
                      {
                        this.state.todos.map((todo,key)=>
                       					
					<div class="list_mob">
                        <Link key={key} to={`/viewTodo/${todo.id}`} name={"max"}>
						<h4 class="list_title">{todo.title}<div class="note_ticket text-inded" dangerouslySetInnerHTML={{__html:todo.note}} /></h4>
						<div class="section">
							<div class="wrap pull-left">
								<label>#To Do:</label><span>{todo.id}</span>
							</div>
							<div class="wrap pull-right">
								<label>Priority</label><div class="text-capitalize">{todo.priority?this.state.config.priority[todo.priority]:'--'}</div>
							</div>
						</div>
						<div class="section gry">
							<div class="wrap">
                            <label>{todo.owner_name?'Owner:':''}</label><span>{todo.owner_name}</span>
							</div>
						</div>
                        </Link>
					</div>
                    
                       )
                    }
				</div>

            {this.loadMorecount()}
          
        </div>
                </div>
            )
        }
    }

    loadMorecount(){
        if(this.state.item_count>0){
            if(this.state.item_count>10){
                if(this.state.isLoadMore!=2){
                    if(this.state.isLoadMore==1){
                        return(
                            <div class="pagination-muvi" id="section07">
                            <div class="load_more" onClick={()=> this.loadMore(this.state.activePage)}><span></span><span></span><span></span></div>
                            </div>
                        )
                    }
                    else{
                        return(
                            <div class="pagination-muvi" id="section07">
                                <div class="lds-ripple"><div></div><div></div></div>
                            </div>
                        )
                    } 
                }
            }
        }
        else{
            return (
                <div className="text-center">No Data Found</div>
            )
        }
    }
    
        loadMore(pageNumber){
            this.setState({isLoadMore:0})
            pageNumber=pageNumber+1;
            this.setState({activePage: pageNumber});
            fetch(this.state.apiUrl + '/todoRest/getTodos/page/'+pageNumber+'/userAuthKey/'+ this.state.userAuthKey+'/userId/' + this.state.userId, {
             method: 'POST',
             dataType: 'json',
             body: JSON.stringify(this.state),
         })
         .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.todos.length == 0) {
                 this.setState({
                     isLoadMore:2
                 })
              }else{
                 this.setState({
                     isLoadMore:1
                 })
              }
             this.setState({
                 todos: this.state.todos.concat(findresponse.todos),
             })
         })
          }
          savedFilterChange(event) {
            var obj = this;
            localStorage.setItem('savedFilter',event.target.value);
            this.setState({
                savedFilter: event.target.value,
            }, function () {
                var all_filters= this.getAllfilterKeys();
                for(var key in all_filters) {
                    if(all_filters[key] != 'savedFilter'){
                        localStorage.setItem(all_filters[key],'');
                        this.setState({[all_filters[key]]: ''});
                    }
                }
                setTimeout(function() {
                    obj.todoList();
                },100);
            });
        }
        multiselectionChange(event, index, value, id) {
            localStorage.setItem(id,value);
            this.setState({[id]:value}, function () {
               this.todoList();
           });

        }
        onChange(event) {
            localStorage.setItem(event.target.name,event.target.value);
            this.setState({[event.target.name]: event.target.value});
        }
    componentDidMount()
    {
        this.todoList();
        this.addTodoDetails();
        var obj = this;
        document.title = "Intranet | To Do List";
        if (!localStorage.getItem('userLogin')) {
            this.setState({redirect: true});
        }
//         var filter_keys = this.getAllfilterKeys();
//         for(var key in localStorage) {
//             if(filter_keys.includes(key)){
               
               
// //                console.log(key+"-------"+localStorage.getItem(key));
               
//                 if(key == 'priority'){
//                     if(localStorage.getItem(key))
//                     this.setState({[key]: localStorage.getItem(key)});
//                 }
                
               
//             }
//           }
//         setTimeout(function() {
//             obj.todoList();
//         },100);
        $(document).ready(function () {
            //Page Refresh
            setTimeout(function(){
                
            },10000);
            //Responsive filter
            $('.top-row .fa-sliders').on('click', function(){
				$(this).closest('.intranet_body').find('.form-section').slideToggle('slow');
			});
        });

    
    }
    render() {
        if(this.state.redirect) {
            return (
              <Redirect to={'/login'} />
            )
        }
        return (
                <div>
                 <Header brecum_name="To Do" brecum_page="To Do List"/>
                <div class="right_col">
                <div class="intranet_body">
                    <div class="title mob hidden-sm">
                        <div class="mob-angle hidden-md pull-left"><i class="fa fa-angle-left" onclick="goBack()"></i></div>
                        <span>To Do List</span>
                        <div class="mob-search hidden-md pull-right">
                            <i class="fa fa-search"></i>
                            <i class="fa fa-sliders" aria-hidden="true"></i>
                        </div>
                    </div>

                    <div class="top-row">
                    <div class="left-section btn-muvi pull-left">
                        <Link to="/addtodo" class="btn btn-sky mob">
                            <span class="hidden-sm">Add To Do</span>
                            <span class="mob_icon_plus hidden-md">
                                <img src={Add_ticket}/>
                            </span>
                        </Link>
                    </div>
                     <div class="right-section">
                        <div class="searchTicket emp_dept">
                            <input type="text" class="form-control" name="search" id="search" placeholder="Search By Id or Keyword" onChange={this.searchChange} /><button type="submit"><i class="fa fa-search"></i></button>
                        </div>
                        <div class="searchTicket filter dept hidden-md"><i class="fa fa-sliders hidden-md filter"></i></div>
                    </div>
                </div>
             <div class="form-section mob_filter">
                <div class="form-horizontal" action="/action_page.php">
                <div class="form-group col-sm-3 col-xs-12">
                <label>Owner</label>
                <div class="filter">
                <select  id="owner" class="form-control" name="owner" value={this.state.owner} onChange={this.ownerChange}>
                   
                    <option value={this.state.userId} selected="selected">[Myself]</option>
                    {
                    this.state.owners.map((owner,key)=>
                    <option value={owner.id}>{owner.name}</option>
                        )
                    }
                </select>
                <i class="fa fa-angle-down" aria-hidden="true"></i>
                 {/* <MuiThemeProvider muiTheme={getMuiTheme()}>
                                <SelectField
                                    multiple
                                    fullWidth={true}
                                    value={this.state.userId}
                                    onChange={(event, index, value) => this.multiselectionChange(event, index, value, "owner")}
                                    maxHeight={200}
                                    >
                                    <MenuItem value={this.state.userId} primaryText='[Myself]' />
                                    {this.state.owners.map((dynamicData, key) =>
                                        <MenuItem value={dynamicData.id} key={key} primaryText={dynamicData.name} />)
                                    }
                                </SelectField>
                </MuiThemeProvider> */}
                 </div> 
                </div>
                <div class="form-group col-sm-3 col-xs-12">
                <label>Priority</label>
                <div class="filter">
                <select class="form-control" name="priority_name" id="priorty"  onChange={this.priortyChange} >
                <option value='' selected >All</option>
                        {
                                        this.state.priority.map((dynamicData,index)=>
                                        <option value={dynamicData.key}>{dynamicData.value}</option>
                                            )
                        }	
                </select>
                <i class="fa fa-angle-down" aria-hidden="true"></i>
                </div>
                </div>
                <div class="form-group col-sm-3 col-xs-12">
                <label>Status</label>
                <div class="filter">
                <select class="form-control" name="status_name" id="status"  onChange={this.statusChange} >
                        <option value='' selected >All</option>
                        {
                                        this.state.status.map((dynamicData,index)=>
                                        <option value={dynamicData.key}>{dynamicData.value}</option>
                                            )
                        }	
                </select>
                <i class="fa fa-angle-down" aria-hidden="true"></i>
                </div>
                </div>
                <div class="form-group col-sm-3 filter_save">
                    <div class="btn-muvi todo-less">
                    <button  className="btn btn-blue" onClick={()=> this.back()}>Reset</button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
                </div>
                {this.getTodoRows()}
                </div>
                </div>
                </div>
                );
    }
}

export default TodoList;


// WEBPACK FOOTER //
// ./src/components/todo/todoList.js